import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center overflow-hidden scroll-mt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-5">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(heroData.primaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(heroData.secondaryCta.href);
                }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-foreground-800 font-semibold text-sm rounded-lg border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.label}
                <i className="ri-grid-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20illustration%20for%20a%20Chinese%20manga%20comic%20website%2C%20featuring%20colorful%20manga%20panels%20floating%20in%20a%20dynamic%20composition%2C%20stylized%20comic%20speech%20bubbles%20with%20Chinese%20text%20elements%2C%20abstract%20line%20art%20and%20action%20speed%20lines%2C%20modern%20flat%20design%20aesthetic%20with%20warm%20orange%20coral%20and%20soft%20cream%20tones%2C%20clean%20gradient%20background%2C%20editorial%20quality%2C%20energetic%20and%20creative%20atmosphere&width=1200&height=900&seq=hero-main-visual&orientation=landscape"
                alt="古古漫画网 - 国漫日漫韩漫大全主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}